// Module
var code = `<div id="file-upload-webcam">
    <div class="modal">
        <div class="modal-header">
            <button type="button" class="close" ng-click="\$ctrl.onClosed()" aria-hidden="true">&times;</button>
            <h2>Webcam</h2>
        </div>
        <div class="modal-body file-upload-webcam__container">
            <webcam channel="\$ctrl.channel"
                    on-stream="\$ctrl.onWebcamStream(stream)"
                    on-error="\$ctrl.onWebcamError(err)"
                    ng-if="!\$ctrl.errorMessage"
            >
            </webcam>
            <button class="btn btn-success file-upload-webcam__button" type="button"
                    ng-click="\$ctrl.takePhoto()" ng-if="\$ctrl.webcamStream">
                Take photo
            </button>
            <canvas class="hide file-upload-webcam__canvas"></canvas>
            <span>
                {{\$ctrl.errorMessage}}
            </span>
        </div>
    </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/file-upload/file-upload-webcam.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;